<template>
  <div class="areas-container">
    <div class="areas-container__areas">
      <button
        v-for="(area, index) of area"
        :class="[
          'areas-container__areas__area',
          { active: area.label == selectedEl },
        ]"
        @click="
          $emit('selectArea', { el: area.label, id: area.id, type: 'areas' })
        "
        :key="'area' + index"
      >
        <p>{{ area.label }}</p>
      </button>
    </div>
    <button
      v-if="checkChart == 'scrollable'"
      class="areas-container__arrow-slider"
      @click="
        $emit('selectArea', { el: area.label, id: area.id, type: 'slider' })
      "
    >
      <icon
        class="areas-container__arrow-slider__icon"
        width="36"
        data="@icon/arrow-right.svg"
      />
    </button>
  </div>
</template>

<script>
// import ClickOutside from "vue-click-outside";
// v-click-outside="resetArea"

export default {
  // directives: {
  //   ClickOutside,
  // },
  props: {
    selectedEl: String,
    area: {
      type: Array,
      required: true,
    },
    checkChart: {
      type: String,
      required: true,
    },
    dragging: Boolean,
    withClickOutside: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.areas-container {
  // width: 100%;
  display: flex;
  // justify-content: center;
  align-items: center;

  &__areas {
    @include link-s;
    height: 1.5rem;
    display: flex;
    gap: 0.15rem;
    color: var(--black-100);

    &__area {
      display: flex;
      align-items: center;
      text-transform: uppercase;
      white-space: nowrap;
      padding: 0 1.25em;
      margin: 0;
      background: var(--white-100);
      transition: background-color 0.3s;

      &:not(.active):hover {
        background: linear-gradient(
            0deg,
            rgba(255, 211, 0, 0.2),
            rgba(255, 211, 0, 0.2)
          ),
          #ffffff;
      }

      &:first-child {
        border-radius: 6px 0 0 6px;
      }
      &:last-child {
        border-radius: 0 6px 6px 0;
      }
      &.active {
        background: var(--primary-yellow);
      }
    }
  }
  &__arrow-slider {
    position: absolute;
    right: 8rem;
    top: 6rem;
    z-index: 6;

    &__icon {
      fill: var(--white-100);
    }
  }
}
</style>
